<template>
  <div class="container-fluid">
    <v-data-table
      :headers="headers"
      :items="drinks"
      sort-by="internalName"
      class="elevation-1"
      :search="search"
      :items-per-page="-1"
      locale="cs"
      :loading="loading"
    >
      <template v-slot:top>
        <v-card
          color="red"
          flat
          tile
        >
          <v-toolbar dense
                     src="https://d2td6mzj4f4e1e.cloudfront.net/wp-content/uploads/sites/9/2019/04/soft-drinks.jpg"
          >
            <v-spacer></v-spacer>
            <v-dialog
              v-model="dialog"
              width="800"
              persistent
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="white"
                  dark
                  v-bind="attrs"
                  v-on="on"
                  outlined
                  @click="editedItem = defaultItem"
                >
                  Přidat nápoj
                </v-btn>
              </template>
              <DrinksForm
                @formCanceled="dialog = false"
                :item="editedItem"
                v-if="dialog"
                @data-saved="getDrinks"
                :food-types="availableFoodTypes"
                :time-types="availableTimeTypes"
                :alergens="availableAlergens"
              ></DrinksForm>
            </v-dialog>
          </v-toolbar>
        </v-card>

        <v-toolbar flat color="white">
          <v-toolbar-title>Databáze nápojů</v-toolbar-title>
          <v-divider
            class="mx-4"
            inset
            vertical
          ></v-divider>
          <v-spacer>Výpis</v-spacer>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Vyhledávání"
            single-line
            hide-details
          ></v-text-field>
        </v-toolbar>
      </template>
      <template v-slot:item.specialOffer="{ item }">
        {{item.specialOffer ? 'Ano' : 'Ne' }}
      </template>
      <template v-slot:item.actions="{ item }">
        <v-icon
          small
          class="mr-2"
          @click="editItem(item)"
        >
          mdi-pencil
        </v-icon>
        <v-icon
          small
          class="mr-2"
          @click="archive(item)"
        >
          mdi-archive-arrow-down
        </v-icon>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="initialize">Reset</v-btn>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import DrinksForm from '../../components/forms/admin/DrinksForm'
export default {
  Name: 'DrinksDatabase',
  components: { DrinksForm },
  data: () => ({
    availableFoodTypes: [],
    availableTimeTypes: [],
    availableAlergens: [],
    search: '',
    dialog: false,
    editedItem: {},
    drinks: [],
    loading: true,
    defaultItem: {
      id: null,
      active: true,
      name: '',
      internalName: '',
      foodTypes: [],
      timeTypes: [],
      alergens: [],
      price: '',
      imageUrl: '',
      volume: '',
      calories: '',
      specialOffer: false
    },
    headers: [
      {
        text: 'Interní název',
        align: 'start',
        sortable: true,
        value: 'internalName'
      },
      { text: 'Název nápoje', value: 'name' },
      { text: 'Typ nápoje', value: 'typesStr' },
      { text: 'Denní doba', value: 'timesStr' },
      { text: 'Alergeny', value: 'alergensStr' },
      { text: 'Cena', value: 'price' },
      { text: 'Objem', value: 'volume' },
      { text: 'Kalorie', value: 'calories' },
      { text: 'Speciální nabídka', value: 'specialOffer' },
      { text: 'Akce', value: 'actions', sortable: false }
    ]
  }),
  created () {
    this.initialize()
  },

  methods: {
    initialize () {
      this.$http.get('/admin/alergens')
        .then(response => {
          this.availableAlergens = this.keysToCamelCase(response.data)
            .filter(alergen => alergen.active)
        })
        .catch(err => {
          console.log(err)
        })
      this.$http.get('/admin/food-types')
        .then(response => {
          this.availableFoodTypes = this.keysToCamelCase(response.data)
            .filter(type => type.active)
        })
      this.$http.get('/times')
        .then(response => {
          this.availableTimeTypes = this.keysToCamelCase(response.data)
            .filter(time => time.active)
        })
      this.getDrinks()
    },
    getDrinks () {
      this.drinks = []
      this.dialog = false
      this.loading = true
      this.$http.get('/admin/drinks')
        .then(response => {
          this.drinks = this.keysToCamelCase(response.data)
            .filter(item => item.visible)
            .map(drink => {
              drink.timesStr = drink.timeTypes
                .map(time => time.name)
                .join(', ')
              drink.typesStr = drink.foodTypes
                .map(type => type.name)
                .join(', ')
              drink.alergensStr = drink.alergens
                .map(alergen => alergen.name)
                .join(', ')
              return drink
            })
          this.loading = false
        })
    },
    editItem (item) {
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },
    archive (item) {
      this.$http.post(`admin/drinks/${item.id}/archive`)
        .then(() => {
          this.getDrinks()
        })
    }
  }
}
</script>

<style scoped>

</style>
